import * as React from 'react';
export const IcUdder = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.15 13A10 10 0 0022 6a1 1 0 00-1-1H3a1 1 0 00-1 1 10 10 0 002.85 7l-1.41 1.75a2 2 0 003.12 2.5l1.61-2c.592.239 1.205.423 1.83.55V19a2 2 0 004 0v-3.2c.626-.13 1.238-.318 1.83-.56l1.61 2A2 2 0 0019 18a2 2 0 001.56-3.25L19.15 13z'
      fill='currentColor'
    />
  </svg>
);
